import request from './request'

// 预签名上传请求
export interface UploadPrepareReq {
  ext: string
  original_name: string
  file_size: number
  mime_type: string
  business_type?: string
  business_id?: string
  is_public?: boolean
}

// 预签名上传响应
export interface UploadPrepareResp {
  id: string
  uploadId: string
  url: string
}

// 上传完成确认请求
export interface UploadConfirmReq {
  id: string
}

// 上传完成确认响应
export interface UploadConfirmResp {
  id: string
  url: string
  object_key: string
}

// 获取预签名上传 URL
export const prepareUpload = (data: UploadPrepareReq): Promise<UploadPrepareResp> => {
  return request.post('/upload/prepare', data)
}

export const uploadToUrl = (
  url: string,
  file: File,
  options?: {
    onProgress?: (progress: number) => void
    signal?: AbortSignal
  }
): Promise<void> => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()

    if (options?.signal) {
      options.signal.addEventListener('abort', () => {
        xhr.abort()
      })
    }

    xhr.upload.addEventListener('progress', (event) => {
      if (event.lengthComputable && options?.onProgress) {
        const progress = Math.round((event.loaded / event.total) * 100)
        options.onProgress(progress)
      }
    })

    xhr.addEventListener('load', () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve()
      } else {
        let errorMsg = '上传失败'
        if (xhr.status === 403) {
          errorMsg = '上传链接已过期，请重新上传'
        } else if (xhr.status === 404) {
          errorMsg = '上传地址不存在'
        } else if (xhr.status >= 500) {
          errorMsg = '服务器错误，请稍后重试'
        }
        reject(new Error(errorMsg))
      }
    })

    xhr.addEventListener('error', () => {
      reject(new Error('上传失败，请检查网络连接'))
    })

    xhr.addEventListener('abort', () => {
      const error = new Error('上传已取消')
      error.name = 'AbortError'
      reject(error)
    })

    xhr.open('PUT', url)
    xhr.send(file)
  })
}

export const confirmUpload = (data: UploadConfirmReq): Promise<UploadConfirmResp> => {
  return request.post('/upload/confirm', data)
}

export const uploadFile = async (
  file: File,
  options?: {
    business_type?: string
    business_id?: string
    is_public?: boolean
    onProgress?: (progress: number) => void
    signal?: AbortSignal
  }
): Promise<{ id: string; url: string; object_key: string }> => {
  const ext = file.name.split('.').pop() || ''

  const prepareResp = await prepareUpload({
    ext,
    original_name: file.name,
    file_size: file.size,
    mime_type: file.type,
    business_type: options?.business_type,
    business_id: options?.business_id,
    is_public: options?.is_public
  })

  await uploadToUrl(prepareResp.url, file, {
    onProgress: options?.onProgress,
    signal: options?.signal
  })

  const confirmResp = await confirmUpload({ id: prepareResp.id })

  return {
    id: confirmResp.id,
    url: confirmResp.url,
    object_key: confirmResp.object_key
  }
}


